export default "__VITE_ASSET__DJYhMc8W__"